import {
  styled, rem
} from 'config/stitches.config'

import { StyledMenuItemLink } from '../styles'

export const StyledMenuFooterWrapper = styled('div', {
  paddingY: '$3',
  borderTop: '1px solid rgba(255,255,255,0.2)',


  '&:last-child': {
    borderBottom: '1px solid rgba(255,255,255,0.2)', '@md': { border: 'none' },
  },
  '&.Contacts': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },

  '&.LowerMenu': { border: 'none' },

  [`& ${StyledMenuItemLink}`]: {
    color: '$accessibleLightGray',
    fontSize: '$footer',
    lineHeight: '$footer',

  },

  '@md': {
    paddingY: 0,
    border: 'none',

    '&.Contacts': { display: 'block' },

    [` ${StyledMenuItemLink}:hover`]: { color: '$white' }
  },

  variants: { columns: { 2: { '@md': { gridColumn: 'span 2' } } } }

})


export const StyledMenuFooterHeader = styled('header', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  columnGap: '$2',

  '.Contacts &': { 'a': { textAlign: 'right', } },

  'a': { textDecoration: 'none' },

  '@md': {
    marginBottom: '$4',
    '.Contacts &': { 'a': { textAlign: 'left', } },
  }
})


export const StyledTriggerButton = styled('button', {
  all: 'unset',
  flexShrink: 0,
  position: 'relative',
  size: '$4',

  '&::before, &::after': {
    content: '',
    width: 1,
    height: 8,
    backgroundColor: '$white',
    position: 'absolute',
    top: '50%',
    left: '50%',
  },

  '&::before': { transform: 'translate(-50%, -50%)', },
  '&::after': { transform: 'translate(-50%, -50%) rotate(90deg)', },

  '@md': { display: 'none' },
})

export const StyledMenuFooterMain = styled('div', {
  marginTop: '$2',
  color: '$accessibleLightGray',

  '.Contacts &': { marginTop: '0', },

  '.FooterInfo': {
    lineHeight: rem(18),
    fontSize: '$footer',
    textAlign: 'left',

    'a': { color: '$accessibleLightGray', },

    '&:not(:last-child)': { marginBottom: '$3', },
  },

  '@md': { marginTop: 0, }
})


export const StyledMenuFooterMainUl = styled('ul', {
  margin: 0,
  padding: 0,

  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  rowGap: '$2',
  columnGap: rem(35),
  '.Contacts &': {
    alignItems: 'flex-end',
    rowGap: '0',
    '@md': { alignItems: 'flex-start', }
  },

  'li': { display: 'block', },

  variants: {
    direction: {
      row: {
        flexDirection: 'row',
        columnGap: rem(60),
        a: { color: '$white !important', },
        '@md': { columnGap: rem(35), }
      }
    },
    columns: {
      2: {
        '@md': {
          display: 'block',
          columnCount: 2,
          'li:not(:last-child)': { marginBottom: '$2' }
        }
      }
    },
    theme: { white: { a: { color: '$white !important', }, } }
  }
})
